<template>
	<el-dialog title="回复" :visible="ReturnBoxDialog" width="70%" @close="close">
		<div>
			<div style="margin-top:30px;" class="send-box">
				<div style="margin-left:20px;"><img :src="avatar" alt=""></div>
				<div class="text-input">
				<textarea style="width:98%;" v-model="items.content" cols="100" rows="10"></textarea>
				</div>
			</div>
			<div class="foot-button" @click="submit"> <button style="margin-right:25px;" :disabled='disabled'>发表评论</button></div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: "return-box",
		props:['ReturnBoxDialog','parent_id','goods_id','avatar'],
		data(){
			return {
				items:{
					content:'',//评论内容
					user_id:'',
					parent_id:'',
					goods_id:''
				},
				disabled:false
			}
		},
		methods:{
			close(){
				this.$emit('update:ReturnBoxDialog',false)
			},
			submit(){
				this.disabled = true
				let _this=this;
				_this.items.user_id=getCookie("user")?getCookie("user"):getCookie("dzq_user_id");
				_this.items.parent_id=_this.$props.parent_id;
				_this.items.goods_id=_this.$props.goods_id;
					if (this.items.content == ''){
						_this.$message({
							type:'error',
							message: '评论不能为空',
							onClose:function(){
								_this.disabled = false
							}
						});
					}
					else{
					_this.$post('/apis/idle/IdleGoodsComment/reply',_this.items).then((res)=>{
						if(res){
							_this.$message({
								type:'success',
								message: '回复成功',
								onClose:function(){
									_this.disabled = false
									location.reload();
								}
							});
					
					}
				})
		}
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/ReturnBox.vue